export { default as WithdrawalOutlineIcon } from './WithdrawalOutlineIcon';
